import SixTemplate from "../../components/Assembler/JSON/SixTemplate";

import { ITypeMedia } from "../../interfaces/Artists";

import type { IStudioArea } from "../../screens/Dashboard/SubComponents/Studio/interfaces/sub-interfaces/Areas.interface";

import type Cameras from "../Devices/Cameras";

class RadioAdapterModel {
  private Model = SixTemplate;

  private Cameras: Cameras | null = null;

  constructor() {
    return this;
  }

  setCameras(cameras: Cameras) {
    this.Cameras = cameras;

    this.setHardware();
  }

  private setHardware() {
    const cameras = this.Cameras?.getAll();

    const device = cameras?.[0] ?? null;

    const cameraDefault = device;

    const areas: IStudioArea[] = this.Model.areas.map((area) => {
      const defaultInfoDevice = {
        deviceId: cameraDefault?.deviceInfo.deviceId || "",

        groupId: cameraDefault?.deviceInfo.groupId || "",

        kind: cameraDefault?.deviceInfo.kind || "",

        label: cameraDefault?.deviceInfo.label || "",
      };

      return {
        ...area,

        media: {
          ...area?.media,

          resource: {
            ...area?.media?.resource,

            id: cameraDefault?.id || "",

            type: ITypeMedia.camera,

            source: defaultInfoDevice,
          },
        },
      };
    });

    this.Model.areas = areas;
  }

  getModel() {
    return this.Model;
  }
}

export default RadioAdapterModel;
